export default "__VITE_ASSET__OYYIjxjc__"